function showCheckoutWarning() {
  const drawer = document.querySelector('.drawer__inner');
  const warningContent = document.getElementById('custom-checkout-warning');
  const warningContainer = document.querySelector('.drawer__warning-container');
  const cartDrawerItems = document.querySelector('cart-drawer-items');
  const cartFooter = document.querySelector('.drawer__footer');

  // Hide entire cart-drawer-items element (not just contents)
  if (cartDrawerItems) cartDrawerItems.style.display = 'none';

  // Hide footer (checkout button) - warning has its own buttons
  if (cartFooter) cartFooter.style.display = 'none';

  // Make warning container fill available space
  if (warningContainer) {
    warningContainer.classList.add('is-active');
  }

  // Show warning content
  if (warningContent) {
    warningContent.classList.remove('hidden');
    warningContent.style.display = 'flex';
  }

  // Scroll to top of drawer
  if (drawer) drawer.scrollTop = 0;
}

function hideCheckoutWarning() {
  const warningContent = document.getElementById('custom-checkout-warning');
  const warningContainer = document.querySelector('.drawer__warning-container');
  const cartDrawerItems = document.querySelector('cart-drawer-items');
  const cartFooter = document.querySelector('.drawer__footer');
  const closeButton = document.querySelector('.drawer__close');

  // Remove active class from warning container
  if (warningContainer) {
    warningContainer.classList.remove('is-active');
  }

  // Hide warning content
  if (warningContent) {
    warningContent.classList.add('hidden');
    warningContent.style.display = 'none';
  }

  // Show cart items and footer
  if (cartDrawerItems) cartDrawerItems.style.display = 'flex';
  if (cartFooter) cartFooter.style.display = 'block';

  // Reset close button
  if (closeButton) {
    closeButton.setAttribute('aria-label', 'Close');
  }
}

function proceedToCheckout() {
  // Redirect directly to checkout
  window.location.href = '/checkout';
}

function handleDrawerClose() {
  const warningContent = document.getElementById('custom-checkout-warning');
  const isWarningVisible =
    warningContent && !warningContent.classList.contains('hidden') && warningContent.style.display !== 'none';

  if (isWarningVisible) {
    // Warning is showing - go back to cart view
    hideCheckoutWarning();
  } else {
    // Normal cart view - ensure state is clean before closing
    resetWarningState();
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    }
  }
}

// Clean up warning state (safety check)
function resetWarningState() {
  const warningContent = document.getElementById('custom-checkout-warning');
  const warningContainer = document.querySelector('.drawer__warning-container');
  const cartDrawerItems = document.querySelector('cart-drawer-items');
  const cartFooter = document.querySelector('.drawer__footer');

  if (warningContainer) {
    warningContainer.classList.remove('is-active');
  }

  if (warningContent) {
    warningContent.classList.add('hidden');
    warningContent.style.display = 'none';
  }

  if (cartDrawerItems) cartDrawerItems.style.display = 'flex';
  if (cartFooter) cartFooter.style.display = 'block';
}

// Make functions globally available - guard to prevent redefinition leaks
if (!window.__checkoutWarningInitialized) {
  window.showCheckoutWarning = showCheckoutWarning;
  window.hideCheckoutWarning = hideCheckoutWarning;
  window.proceedToCheckout = proceedToCheckout;
  window.handleDrawerClose = handleDrawerClose;
  window.__checkoutWarningInitialized = true;
}
